import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { auth } from "../../db/config";

export default function Header() {
  const userReducer = useSelector((state) => state.userReducer);
  const getUserDetails = userReducer.currentUser;
  const handleLogOut = () => {
    auth.signOut().then(() => {
      window.location.href = "/login";
    });
  };

  return (
    <div>
      <div class="cursor"></div>
      <div class="cursor"></div>

      <a href="javascript:" id="return-to-top">
        {" "}
        <i class="fas fa-angle-double-up"></i>
      </a>

      <nav class="cd-dropdown d-block d-sm-block d-md-block d-lg-none d-xl-none">
        <h2>{/* <a> Treasure Growth Investment </a> */}</h2>
        <a href="#0" class="cd-close">
          Close
        </a>
        <ul class="cd-dropdown-content">
          <li>
            <form class="cd-search">
              <input type="search" placeholder="Search..." />
            </form>
          </li>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/about"> about us </a>
          </li>
          <li>
            <a href="/investment"> investment plan </a>
          </li>
          <li>
            <a href="/faq"> FAQ </a>
          </li>

          <li
            class="has-children"
            style={{ display: getUserDetails !== null ? "block" : "none" }}
          >
            <a href="#">dashboard</a>
            <ul class="cd-secondary-dropdown icon_menu is-hidden">
              <li class="go-back">
                <a href="#0">Menu</a>
              </li>
              <li>
                <a href="/fund_transfer_history">fund transfer history</a>
              </li>
              {/* <li>
                  <a href="banners.html">banners</a>
                </li> */}
              <li>
                <a href="/change_password">change password</a>
              </li>
              <li>
                <a href="/change_pin">change pin</a>
              </li>
              <li>
                <a href="deposit_history.html">deposit history</a>
              </li>
              <li>
                <a href="/deposit_list">deposit list</a>
              </li>
              <li>
                <a href="earnings_history.html">earnings history</a>
              </li>
              {/* <li>
                  <a href="email_notification.html">email notification</a>
                </li> */}
              <li>
                <a href="exchange_history.html">exchange history</a>
              </li>
              <li>
                <a href="exchange_money.html">exchange money</a>
              </li>
              <li>
                <a href="/deposit">make deposit</a>
              </li>
              <li>
                <a href="/my_account">my account</a>
              </li>
              <li>
                <a href="/payment_request">payment request</a>
              </li>
              {/* <li>
                  <a href="pending_history.html">pending history</a>
                </li> */}
              <li>
                <a href="/referral_list">referral list</a>
              </li>
              <li>
                <a href="/referrals">referrals</a>
              </li>
              {/* <li>
                  <a href="tickets.html">tickets</a>
                </li> */}
              <li>
                <a href="/transfer_fund">transfer fund</a>
              </li>
              <li>
                <a href="/profile">view profile</a>
              </li>
            </ul>
          </li>

          {/* <li class="has-children">
            <a href="#">blog</a>
            <ul class="cd-secondary-dropdown icon_menu is-hidden">
              <li class="go-back">
                <a href="#0">Menu</a>
              </li>
              <li>
                <a href="blog_category.html">blog category</a>
              </li>
              <li>
                <a href="blog_single.html">blog single</a>
              </li>
            </ul>
          </li> */}
          <li>
            <a href="/contact"> contact us </a>
          </li>
          {getUserDetails !== null ? (
            <li>
              <a onClick={handleLogOut}> logout </a>
            </li>
          ) : (
            <li>
              <a href="/login"> login </a>
            </li>
          )}
          {getUserDetails !== null ? (
            ""
          ) : (
            <li>
              <a href="/register"> register </a>
            </li>
          )}
        </ul>
      </nav>
      <div class="cp_navi_main_wrapper float_left">
        <div class="container-fluid">
          <div class="cp_logo_wrapper">
            <a href="/">
              <img
                src="images/logo-white-t.png"
                alt="logo"
                style={{ objectFit: "contain", width: "150px" }}
              />
              {/* Treasure Growth<br></br> Investment */}
            </a>
          </div>

          <header class="mobail_menu d-block d-sm-block d-md-block d-lg-none d-xl-none">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12">
                  <div class="cd-dropdown-wrapper">
                    <a class="house_toggle" href="#0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 31.177 31.177"
                        enableBackground="new 0 0 31.177 31.177;"
                        xmlSpace="preserve"
                        width="25px"
                        height="25px"
                      >
                        <g>
                          <g>
                            <path
                              class="menubar"
                              d="M30.23,1.775H0.946c-0.489,0-0.887-0.398-0.887-0.888S0.457,0,0.946,0H30.23    c0.49,0,0.888,0.398,0.888,0.888S30.72,1.775,30.23,1.775z"
                              fill="#004165"
                            />
                          </g>
                          <g>
                            <path
                              class="menubar"
                              d="M30.23,9.126H12.069c-0.49,0-0.888-0.398-0.888-0.888c0-0.49,0.398-0.888,0.888-0.888H30.23    c0.49,0,0.888,0.397,0.888,0.888C31.118,8.729,30.72,9.126,30.23,9.126z"
                              fill="#004165"
                            />
                          </g>
                          <g>
                            <path
                              class="menubar"
                              d="M30.23,16.477H0.946c-0.489,0-0.887-0.398-0.887-0.888c0-0.49,0.398-0.888,0.887-0.888H30.23    c0.49,0,0.888,0.397,0.888,0.888C31.118,16.079,30.72,16.477,30.23,16.477z"
                              fill="#004165"
                            />
                          </g>
                          <g>
                            <path
                              class="menubar"
                              d="M30.23,23.826H12.069c-0.49,0-0.888-0.396-0.888-0.887c0-0.49,0.398-0.888,0.888-0.888H30.23    c0.49,0,0.888,0.397,0.888,0.888C31.118,23.43,30.72,23.826,30.23,23.826z"
                              fill="#004165"
                            />
                          </g>
                          <g>
                            <path
                              class="menubar"
                              d="M30.23,31.177H0.946c-0.489,0-0.887-0.396-0.887-0.887c0-0.49,0.398-0.888,0.887-0.888H30.23    c0.49,0,0.888,0.398,0.888,0.888C31.118,30.78,30.72,31.177,30.23,31.177z"
                              fill="#004165"
                            />
                          </g>
                        </g>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </header>
          <div class="top_header_right_wrapper">
            <p>
              <i class="flaticon-phone-contact"></i> +1 (863) 617-6411
            </p>
            <div class="header_btn">
              {getUserDetails !== null ? (
                <li>
                  <a style={{ background: "red" }} onClick={handleLogOut}>
                    {" "}
                    logout{" "}
                  </a>{" "}
                </li>
              ) : (
                <ul>
                  <li>
                    <a href="/register"> register </a>{" "}
                  </li>
                  <li>
                    <a href="/login"> login </a>{" "}
                  </li>
                </ul>
              )}
            </div>
          </div>

          <div class="cp_navigation_wrapper">
            <div class="mainmenu d-xl-block d-lg-block d-md-none d-sm-none d-none">
              <ul class="main_nav_ul">
                <li class="has-mega gc_main_navigation">
                  <a href="/" class="gc_main_navigation active_class">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" class="gc_main_navigation">
                    {" "}
                    about us{" "}
                  </a>
                </li>
                <li>
                  <a href="/investment" class="gc_main_navigation">
                    investment plan
                  </a>
                </li>
                <li>
                  <a href="/faq" class="gc_main_navigation">
                    faq
                  </a>
                </li>

                {getUserDetails !== null ? (
                  <li class="has-mega gc_main_navigation">
                    <a href="#" class="gc_main_navigation">
                      dashboard <i class="fas fa-caret-down"></i>
                    </a>
                    <ul class="navi_2_dropdown">
                      <li class="parent">
                        <a href="#">
                          <i class="fas fa-caret-right"></i>my account
                          <span>
                            <i class="fas fa-caret-right"></i>
                          </span>
                        </a>
                        <ul class="dropdown-menu-right">
                          <li>
                            <a href="/my_account">
                              {" "}
                              <i class="fas fa-caret-right"></i>my account{" "}
                            </a>
                          </li>
                          <li>
                            <a href="/profile">
                              {" "}
                              <i class="fas fa-caret-right"></i> my profile
                            </a>
                          </li>
                          {/* <li>
                            <a href="email_notification.html">
                              <i class="fas fa-caret-right"></i>email
                              notification
                            </a>
                          </li> */}
                          <li>
                            <a href="/change_password">
                              <i class="fas fa-caret-right"></i>change password
                            </a>
                          </li>
                          <li>
                            <a href="/change_pin">
                              <i class="fas fa-caret-right"></i>change pin
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li class="parent">
                        <a href="#">
                          {" "}
                          <i class="fas fa-caret-right"></i>finance
                          <span>
                            {" "}
                            <i class="fas fa-caret-right"></i>
                          </span>
                        </a>
                        <ul class="dropdown-menu-right">
                          <li>
                            <a href="/deposit">
                              {" "}
                              <i class="fas fa-caret-right"></i>make deposit
                            </a>
                          </li>
                          <li>
                            <a href="/deposit_list">
                              {" "}
                              <i class="fas fa-caret-right"></i> deposit lists
                            </a>
                          </li>
                          <li>
                            <a href="/payment_request">
                              <i class="fas fa-caret-right"></i>payment request
                            </a>
                          </li>
                          <li>
                            <a href="exchange_money.html">
                              <i class="fas fa-caret-right"></i>exchange money
                            </a>
                          </li>
                          <li>
                            <a href="/transfer_fund">
                              <i class="fas fa-caret-right"></i>fund transfer
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li class="parent">
                        <a href="#">
                          {" "}
                          <i class="fas fa-caret-right"></i>reports
                          <span>
                            {" "}
                            <i class="fas fa-caret-right"></i>
                          </span>
                        </a>
                        <ul class="dropdown-menu-right">
                          <li>
                            <a href="/fund_transfer_history">
                              {" "}
                              <i class="fas fa-caret-right"></i>fund transfer
                              history
                            </a>
                          </li>
                          <li>
                            <a href="/deposit">
                              {" "}
                              <i class="fas fa-caret-right"></i> deposit history
                            </a>
                          </li>
                          {/* <li>
                            <a href="pending_history.html">
                              <i class="fas fa-caret-right"></i>pending history
                            </a>
                          </li> */}
                          <li>
                            <a href="exchange_history.html">
                              <i class="fas fa-caret-right"></i>exchange history
                            </a>
                          </li>
                          <li>
                            <a href="earnings_history.html">
                              <i class="fas fa-caret-right"></i>earning history
                            </a>
                          </li>
                        </ul>
                      </li>
                      <li class="parent">
                        <a href="#">
                          {" "}
                          <i class="fas fa-caret-right"></i>referrals
                          <span>
                            {" "}
                            <i class="fas fa-caret-right"></i>
                          </span>
                        </a>
                        <ul class="dropdown-menu-right">
                          <li>
                            <a href="/referrals">
                              {" "}
                              <i class="fas fa-caret-right"></i>my referrals
                            </a>
                          </li>
                          {/* <li>
                            <a href="banners.html">
                              {" "}
                              <i class="fas fa-caret-right"></i> promotionals
                              banners
                            </a>
                          </li> */}
                          <li>
                            <a href="/referral_list">
                              <i class="fas fa-caret-right"></i>referral list
                            </a>
                          </li>
                        </ul>
                      </li>
                      {/* <li class="parent">
                        <a href="tickets.html">
                          <i class="fas fa-caret-right"></i>view tickets
                        </a>
                      </li> */}
                    </ul>
                  </li>
                ) : (
                  ""
                )}

                {/* <li class="has-mega gc_main_navigation">
                  <a href="#" class="gc_main_navigation">
                    blog <i class="fas fa-caret-down"></i>
                  </a>
                  <ul class="navi_2_dropdown">
                    <li class="parent">
                      <a href="blog_category.html">
                        <i class="fas fa-caret-right"></i>blog category
                      </a>
                    </li>
                    <li class="parent">
                      <a href="blog_single.html">
                        <i class="fas fa-caret-right"></i> blog single
                      </a>
                    </li>
                  </ul>
                </li> */}
                <li>
                  <a href="/contact" class="gc_main_navigation">
                    contact us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
